import { stylesheet } from 'typestyle';
import { flexRoot, horizontal } from 'csstips';

export default stylesheet({
  container: {
    height: 67,
    borderBottom: '1px solid #e1e1e1',
    borderTop: '1px solid #e1e1e1',
    zIndex: 2,
    order: 4,

    br: {
      display: 'none'
    },

    $nest: {
      '@media (min-width: 375px) and (max-width: 694px)': {
        height: 134
      },

      '@media (min-width: 545px) and (max-width: 694px)': {
        '& br:nth-of-type(3)': {
          display: 'block'
        }
      },

      '@media (min-width: 0px) and (max-width: 374px)': {
        height: 201,

        '& br:nth-of-type(1)': {
          display: 'block'
        },

        '& br:nth-of-type(3)': {
          display: 'block'
        }
      },

      '@media (min-width: 420px) and (max-width: 544px)': {
        '& br:nth-of-type(2)': {
          display: 'block'
        }
      }
    }
  },

  style: {},
  styleTab: {
    width: 103,

    '@media (max-width: 694px)': {
      borderBottom: 'none'
    }
  },
  styleContent: {
    width: 198,

    $nest: {
      '@media (min-width: 470px) and (max-width: 694px)': {
        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 101,
          width: 'calc(100% - 101px)'
        }
      },

      '@media (min-width: 421px) and (max-width: 469px)': {
        left: -50,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 50
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 45
        }
      },

      '@media (min-width: 375px) and (max-width: 420px)': {
        left: 'auto',
        right: 0,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 95
        }
      },

      '@media (min-width: 0px) and (max-width: 374px)': {
        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 95
        }
      }
    }
  },

  metal: {},
  metalTab: {
    width: 100,

    '@media (max-width: 694px)': {
      borderBottom: 'none'
    }
  },
  metalContent: {
    width: 198,

    $nest: {
      '@media (min-width: 375px) and (max-width: 694px)': {
        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 98,
          width: 'calc(100% - 98px)'
        }
      },

      '@media (min-width: 0px) and (max-width: 374px)': {
        left: -50,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 50
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 48
        }
      }
    }
  },

  priceRange: {},
  priceRangeTab: {
    width: 144
  },
  priceRangeContent: {
    width: 313,

    ul: {
      ...flexRoot,
      ...horizontal,
      width: 226,
      justifyContent: 'space-between',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '15px !important'
    },

    li: {
      marginBottom: 3
    },

    '@media (min-width: 805px)': {
      left: -50
    },

    '@media (min-width: 755px) and (max-width: 804px)': {
      left: -100
    },

    '@media (min-width: 705px) and (max-width: 754px)': {
      left: -150
    },

    '@media (min-width: 695px) and (max-width: 704px)': {
      left: 'auto',
      right: 0
    },

    '@media (min-width: 545px) and (max-width: 694px)': {
      left: 0,
      right: 'auto'
    },

    '@media (min-width: 500px) and (max-width: 529px)': {
      left: -30,
      right: 'auto'
    },

    '@media (min-width: 470px) and (max-width: 499px)': {
      left: -60,
      right: 'auto'
    },

    '@media (min-width: 440px) and (max-width: 469px)': {
      left: -90,
      right: 'auto'
    },

    '@media (min-width: 375px) and (max-width: 439px)': {
      left: -120,
      right: 'auto'
    },

    '@media (min-width: 0px) and (max-width: 374px)': {
      left: 0,
      right: 'auto'
    },

    $nest: {
      '& input[type="radio"] + label': {
        margin: 0
      },

      // Reset bottom margin on component container
      '& > [class^=container]': {
        margin: '0 auto',
        height: 'auto'
      }
    }
  },

  shape: {},
  shapeTab: {
    width: 156,

    '@media (max-width: 694px)': {
      borderBottom: 'none'
    }
  },
  shapeContent: {
    width: 280,

    $nest: {
      '@media (max-width: 694px)': {
        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 154,
          width: 125
        }
      },

      // Reset -20px horizontal margin on icon container
      '& [class^=iconContainer]': {
        margin: 0,

        $nest: {
          '& div:nth-of-type(1n+6)': {
            marginTop: 25
          }
        }
      },

      // Reset bottom margin on component container
      '& > [class^=container]': {
        margin: '0 auto',
        height: 'auto'
      }
    }
  },

  design: {},
  designTab: {
    width: 115,

    '@media (min-width: 545px) and (max-width: 694px)': {
      borderBottom: 'none'
    },

    '@media (min-width: 0px) and (max-width: 374px)': {
      borderBottom: 'none'
    }
  },
  designContent: {
    width: 198,

    $nest: {
      '@media (min-width: 655px) and (max-width: 694px)': {
        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 83
        }
      },

      '@media (min-width: 605px) and (max-width: 654px)': {
        left: 'auto',
        right: -30,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 53
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 30
        }
      },

      '@media (min-width: 545px) and (max-width: 604px)': {
        left: 'auto',
        right: 0,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 83
        }
      },

      '@media (min-width: 0px) and (max-width: 374px)': {
        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 83
        }
      }
    }
  }
});
